import axios from 'axios';

export const fetchAboutsShort = async () => {
    const language = await localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get(
        'https://admin.regional-group.com/api/abouts-short',
        {
            headers: {
                'Accept-Language': language, // Change 'en-US' to the desired language code
            },
        }
    );
    return response.data;
};

export const fetchAboutsBanner = async () => {
    const response = await axios.get(
        'https://admin.regional-group.com/api/abouts-banner'
    );
    return response.data;
};

export const fetchEbaut = async () => {
    const language = await localStorage.getItem('Accept-Language') || "ru";
    const response = await axios.get('https://admin.regional-group.com/api/abouts', {
        headers: {
            'Accept-Language': language, // Change 'en-US' to the desired language code
        },
    });
    return response.data;
};
export const fetchAboutSeo = async () => {
    const language = await localStorage.getItem('Accept-Language') || "ru";
    const response = await axios.get('https://admin.regional-group.com/api/seo/about', {
        headers: {
            'Accept-Language': language, // Change 'en-US' to the desired language code
        },
    });
    return response.data;
};
export const fetchGallerySeo = async () => {
    const language = await localStorage.getItem('Accept-Language') || "ru";
    const response = await axios.get('https://admin.regional-group.com/api/seo/gallery', {
        headers: {
            'Accept-Language': language, // Change 'en-US' to the desired language code
        },
    });
    return response.data;
};
export const fetchHomeSeo = async () => {
    const language = await localStorage.getItem('Accept-Language') || "ru";
    const response = await axios.get('https://admin.regional-group.com/api/seo/home', {
        headers: {
            'Accept-Language': language, // Change 'en-US' to the desired language code
        },
    });
    return response.data;
};
export const fetchNewsSeo = async () => {
    const language = await localStorage.getItem('Accept-Language') || "ru";
    const response = await axios.get('https://admin.regional-group.com/api/seo/blog', {
        headers: {
            'Accept-Language': language, // Change 'en-US' to the desired language code
        },
    });
    return response.data;
};
export const fetchServicesSeo = async () => {
    const language = await localStorage.getItem('Accept-Language') || "ru";
    const response = await axios.get('https://admin.regional-group.com/api/seo/service', {
        headers: {
            'Accept-Language': language, // Change 'en-US' to the desired language code
        },
    });
    return response.data;
};
export const fetchAservices = async () => {
    const language = await localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get('https://admin.regional-group.com/api/services', {
        headers: {
            'Accept-Language': language, // Change 'en-US' to the desired language code
        },
    });
    
    return response.data;
};
export const fetchAservicesBunner = async () => {
    const language = await localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get(
        'https://admin.regional-group.com/api/services-banner',
        {
            headers: {
                'Accept-Language': language, // Change 'en-US' to the desired language code
            },
        }
    );
    return response.data;
};
export const fetchContactBunner = async () => {
    const language = localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get(
        'https://admin.regional-group.com/api/contacts-banner',
        {
            headers: {
                'Accept-Language': language, // Change 'en-US' to the desired language code
            },
        }
    );
    return response.data;
};
export const fetchContact = async () => {
    const language = localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get('https://admin.regional-group.com/api/contacts', {
        headers: {
            'Accept-Language': language, // Change 'en-US' to the desired language code
        },
    });
    return response.data;
};
export const fetchContactSeo = async () => {
    const language = localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get('https://admin.regional-group.com/api/seo/contact', {
        headers: {
            'Accept-Language': language, // Change 'en-US' to the desired language code
        },
    });
    return response.data;
};
export const fetchEbautBunner = async () => {
    const language = await localStorage.getItem('Accept-Language') || "ru";
    const response = await axios.get(
        'https://admin.regional-group.com/api/abouts-banner',
        {
            headers: {
                'Accept-Language': language, // Change 'en-US' to the desired language code
            },
        }
    );
    return response.data;
};
export const fetchStatistics = async () => {
    const language = await localStorage.getItem('Accept-Language') || "ru";
    const response = await axios.get(
        'https://admin.regional-group.com/api/statistics',
        {
            headers: {
                'Accept-Language': language, // Change 'en-US' to the desired language code
            },
        }
    );
    return response.data;
};
export const fetchService_extra = async () => {
    const language = localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get(
        'https://admin.regional-group.com/api/service-extra',
        {
            headers: {
                'Accept-Language': language, // Change 'en-US' to the desired language code
            },
        }
    );
    return response.data;
};
export const fetchBlog = async () => {
    const language = localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get('https://admin.regional-group.com/api/news', {
        headers: {
            'Accept-Language': language, // Change 'en-US' to the desired language code
        },
    });

    return response.data;
};
export const fetchBlogById = async (id) => {
    const language = localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get(
        `https://admin.regional-group.com/api/news/${id}`,
        {
            headers: {
                'Accept-Language': language, // Change 'en-US' to the desired language code
            },
        }
    );
    return response.data;
};
export const fetchBlogByCategory = async (category) => {
    const language = localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get(
        `https://admin.regional-group.com/api/news?type=${category}`,
        {
            headers: {
                'Accept-Language': language, // Change 'en-US' to the desired language code
            },
        }
    );
    return response.data;
};
export const fetchBunner = async () => {
    const language = localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get(
        'https://admin.regional-group.com/api/news-banner',
        {
            headers: {
                'Accept-Language': language, // Change 'en-US' to the desired language code
            },
        }
    );
    return response.data;
};
export const fetchFooterData = async () => {
    const language = localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get('https://admin.regional-group.com/api/footer', {
        headers: {
            'Accept-Language': language, // Change 'en-US' to the desired language code
        },
    });

    return response.data;
};
export const fetcGalery = async (page) => {
    const response = await axios.get(
        `https://admin.regional-group.com/api/galery?page=${page}`
    );
    return response.data;
};
export const fetcGaleryBunner = async () => {
    const language = localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get(
        'https://admin.regional-group.com/api/galery-banner',
        {
            headers: {
                'Accept-Language': language, // Change 'en-US' to the desired language code
            },
        }
    );
    return response.data;
};
export const fetchTranslates = async () => {
    const language = localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get('https://admin.regional-group.com/api/translates', {
        headers: {
            'Accept-Language': language,
        },
    });

    return response;
};
export const fetchPromotion = async () => {
    const language = localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get('https://admin.regional-group.com/api/promotion', {
        headers: {
            'Accept-Language': language,
        },
    });

    return response;
};

export const fetchLogo = async () => {
    const language = localStorage.getItem('Accept-Language') || "ru";

    const response = await axios.get('https://admin.regional-group.com/api/logo', {
        headers: {
            'Accept-Language': language,
        },
    });

    return response;
};